import "core-js/modules/web.dom-collections.iterator.js";
import { computed } from "mobx";

/**
 * Adds a set of traits to a model. The values of the traits will be derived
 * from the model's strata.
 * @param model The model class or instance.
 * @param Traits The traits class.
 * @returns The original model, now modified to add the added traits.
 */

export default function addModelStrataView(model, Traits) {
  const traits = Traits.traits;
  const decorators = {};
  const propertyTarget = typeof model === "function" ? model.prototype : model;
  const traitsInstance = new Traits();
  Object.keys(traits).forEach(traitName => {
    const trait = traits[traitName];
    const defaultValue = traitsInstance[traitName];
    Object.defineProperty(propertyTarget, traitName, {
      get: function () {
        const value = trait.getValue(this);
        return value === undefined ? defaultValue : value;
      },
      enumerable: true,
      configurable: true
    });
    decorators[traitName] = trait.decoratorForFlattened || computed;
  });
  decorate(model, decorators);
  return model;
}

/**
 * Decorate the target class.
 *
 * Note that we assume that the class constructor calls `makeObservable(this)`
 * to correctly setup the mobx properties.
 *
 * @param target Target class to decorate
 * @param decorators Properties of the class that must be decorated
 */
function decorate(target, decorators) {
  Object.entries(decorators).forEach(_ref => {
    let [prop, decorator] = _ref;
    decorator(target.prototype, prop);
  });
}